export const VOYAGER_PRIVACY = "https://getvoyager.app/privacy.html";
export const VOYAGER_TERMS = "https://getvoyager.app/terms.html";
